import * as React from "react";
import { StoreProvider } from "./src/components/StoreContext";

export const onServiceWorkerUpdateReady = () => window.location.reload();

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <StoreProvider>{element}</StoreProvider>
);

// This code potentially is needed to push custom "gatsby-route-change" event, but looks like we don't need it.

// const currentEnvironment =
//   process.env.ENV || process.env.NODE_ENV || "development";
// const routeChangeEventName = "gatsby-route-change";

// const updateGtmDataLayer = async (location: Location) => {
//   if (isGtmInitialized) {
//     const userHasAccepted = localStorage.getItem("consentGiven"); // get local storage value here

//     if (userHasAccepted) {
//     TagManager.dataLayer({
//       dataLayer: {
//         event: routeChangeEventName,
//         value: location.pathname,
//       },
//     });
//     }
//   }
// };

// export const onRouteUpdate = ({ location }: { location: Location }) => {
//   // if (currentEnvironment !== "production") {
//   //   return;
//   // }

//   updateGtmDataLayer(location);
// };

// if needed below function is executed on application start, so can be used to initialize GTM
// export const onClientEntry = (): void => {
//   if (currentEnvironment !== "production") {
//     return;
//   }

//   initializeGtm();
// };
